import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import toast from 'react-hot-toast';

export const LayerPaymentFailure = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { orderId, error } = location.state || {};

  useEffect(() => {
    if (error) {
      toast.error('Payment failed. Your order has been cancelled.');
    } else if (!orderId) {
      // No order data, redirect to home
      navigate('/');
    }
  }, [orderId, error, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <XCircle className="h-16 w-16 text-red-500" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Failed</h1>
          <p className="text-gray-600 mb-6">
            {error || 'We encountered an issue processing your payment. Please try again.'}
          </p>
          
          {orderId && (
            <div className="bg-gray-50 rounded-lg p-4 text-left mb-6">
              <h3 className="font-semibold text-gray-900 mb-3">Transaction Details</h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600">Order ID:</span>
                  <span className="font-medium">{orderId}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Status:</span>
                  <span className="font-medium text-red-600 capitalize">Failed</span>
                </div>
              </div>
            </div>
          )}
          
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-amber-800">
              <strong>Note:</strong> No amount has been deducted from your account. You can try placing the order again.
            </p>
          </div>
          
          <div className="space-y-3">
            <button
              onClick={() => navigate('/cart')}
              className="btn-primary btn-lg w-full"
            >
              Return to Cart
            </button>
            <button
              onClick={() => navigate('/')}
              className="btn-outline btn-lg w-full"
            >
              Continue Shopping
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

